"use client";

import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { Music, Lightbulb, Headphones } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurServices() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const services = [{
    icon: Music,
    title: "Wedding DJ Services",
    description: "Professional DJ services tailored to make your special day unforgettable with personalized playlists and seamless transitions.",
    link: "#"
  }, {
    icon: Lightbulb,
    title: "Event Lighting Design",
    description: "Transform your venue with custom lighting setups that create the perfect ambiance for your celebration.",
    link: "#"
  }, {
    icon: Headphones,
    title: "AV Sound Equipment",
    description: "High-quality audio and visual equipment ensuring crystal-clear sound and flawless event production.",
    link: "#"
  }];
  return <section id="our-services" className="bg-light-background py-16 px-6 md:px-12 lg:px-24">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-display text-4xl md:text-5xl font-bold text-foreground-light mb-4">
            Our Services
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Comprehensive entertainment solutions for your Denver wedding and event needs
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div ref={ref1} data-index={0} className={`transition-all duration-[var(--duration-medium)] ${isVisible1 ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <Card className="h-full hover:-translate-y-0.5 hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] bg-background border border-border shadow-soft">
              <CardHeader>
                <div className="mb-4 inline-flex items-center justify-center w-14 h-14 rounded-lg bg-primary/10">
                  <Music className="size-7 text-primary" />
                </div>
                <CardTitle className="text-2xl font-semibold text-foreground-light">
                  {services[0].title}
                </CardTitle>
              </CardHeader>
              <CardContent className="flex flex-col gap-4">
                <CardDescription className="text-muted-foreground leading-relaxed">
                  {services[0].description}
                </CardDescription>
                <Link to={services[0].link} className="inline-flex items-center text-primary font-semibold hover:text-primary-hover hover:underline transition-colors duration-[var(--duration-fast)] focus-ring">
                  Learn More
                  <svg className="ml-2 size-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </Link>
              </CardContent>
            </Card>
          </div>

          <div ref={ref2} data-index={1} className={`transition-all duration-[var(--duration-medium)] delay-100 ${isVisible2 ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <Card className="h-full hover:-translate-y-0.5 hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] bg-background border border-border shadow-soft">
              <CardHeader>
                <div className="mb-4 inline-flex items-center justify-center w-14 h-14 rounded-lg bg-primary/10">
                  <Lightbulb className="size-7 text-primary" />
                </div>
                <CardTitle className="text-2xl font-semibold text-foreground-light">
                  {services[1].title}
                </CardTitle>
              </CardHeader>
              <CardContent className="flex flex-col gap-4">
                <CardDescription className="text-muted-foreground leading-relaxed">
                  {services[1].description}
                </CardDescription>
                <Link to={services[1].link} className="inline-flex items-center text-primary font-semibold hover:text-primary-hover hover:underline transition-colors duration-[var(--duration-fast)] focus-ring">
                  Learn More
                  <svg className="ml-2 size-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </Link>
              </CardContent>
            </Card>
          </div>

          <div ref={ref3} data-index={2} className={`transition-all duration-[var(--duration-medium)] delay-200 ${isVisible3 ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <Card className="h-full hover:-translate-y-0.5 hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] bg-background border border-border shadow-soft">
              <CardHeader>
                <div className="mb-4 inline-flex items-center justify-center w-14 h-14 rounded-lg bg-primary/10">
                  <Headphones className="size-7 text-primary" />
                </div>
                <CardTitle className="text-2xl font-semibold text-foreground-light">
                  {services[2].title}
                </CardTitle>
              </CardHeader>
              <CardContent className="flex flex-col gap-4">
                <CardDescription className="text-muted-foreground leading-relaxed">
                  {services[2].description}
                </CardDescription>
                <Link to={services[2].link} className="inline-flex items-center text-primary font-semibold hover:text-primary-hover hover:underline transition-colors duration-[var(--duration-fast)] focus-ring">
                  Learn More
                  <svg className="ml-2 size-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </Link>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}